
export const SELECT_REPORT = 'print/ui/SELECT_REPORT';
export const SET_GEOM_CONDITION = 'print/ui/SET_GEOM_CONDITION';
export const SET_IS_GEO_ACTIVE = 'print/ui/SET_IS_GEO_ACTIVE';
export const SET_IS_VALID = 'print/ui/SET_IS_VALID';
export const SET_PARAM_VALUE = 'print/ui/SET_PARAM_VALUE';

export default function getActions(dispatch) {
    return {
        selectReport: (reportId, reportType) => dispatch({
            type: SELECT_REPORT,
            reportId, reportType
        }),
        setGeomCondition: (geometry, condition) => dispatch({
            type: SET_GEOM_CONDITION,
            geometry, condition
        }),
        setIsGeoActive: (active) => dispatch({
            type: SET_IS_GEO_ACTIVE,
            active
        }),
        setIsValid: (isValid) => dispatch({
            type: SET_IS_VALID,
            isValid
        }),
        setParamValue: (paramId, value) => dispatch({
            type: SET_PARAM_VALUE,
            paramId, value
        })
    };
}
